import CustomLeafletControl from 'components/BaseMap/components/CustomLeafletControl';
import { DOPPLER_CONFIG } from '../../../../config/dopplerRadar.config.js';
import { formatDopplerFrameTime } from '../../../../utils/dopplerDisplay.utils.js';

const PRECIPITATION_GRADIENT = DOPPLER_CONFIG.precipitationGradient;

export default function DopplerMetaControls({ compact = false, frames, displayedFrameIndex }) {
  const currentFrame = frames[displayedFrameIndex];
  const metaCardWidth = compact ? 156 : 188;

  if (!currentFrame) {
    return null;
  }

  const formattedTime = formatDopplerFrameTime(currentFrame);

  return (
    <CustomLeafletControl position="bottomright">
      <div className="doppler-meta-controls d-flex flex-column align-items-end gap-2 pe-1 pb-1">
        <div
          className="doppler-frame-time d-flex align-items-center justify-content-end fw-bold text-end lh-1 text-nowrap"
          style={{
            width: metaCardWidth,
            minHeight: compact ? 40 : 52,
            fontSize: compact ? '2rem' : '2.5rem',
          }}
        >
          {formattedTime}
        </div>

        <div
          className="doppler-legend-card bg-white border rounded-3 shadow-sm px-1 py-1"
          style={{ width: metaCardWidth }}
        >
          <div className="doppler-legend-title small fw-semibold text-dark mb-0">Precipitation</div>
          <div
            className="rounded-pill"
            style={{
              height: compact ? 10 : 12,
              background: PRECIPITATION_GRADIENT,
            }}
          />
          <div className="doppler-legend-scale mt-2 d-flex justify-content-between small text-dark">
            <span>Light</span>
            <span>Heavy</span>
          </div>
        </div>
      </div>
    </CustomLeafletControl>
  );
}
